<div
  class="app-code-editor"
  [class.app-code-editor--readonly]="readOnly && !processing"
  [class.app-code-editor--processing]="processing">
  <div #editor></div>
</div>
